import { render, staticRenderFns } from "./AddKbliSearch.vue?vue&type=template&id=3b43cf49&scoped=true&"
import script from "./AddKbliSearch.vue?vue&type=script&lang=js&"
export * from "./AddKbliSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddKbliSearch.vue?vue&type=style&index=0&id=3b43cf49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43cf49",
  null
  
)

export default component.exports